import { WorkflowTemplateRepository, WorkflowTestRepository } from "../domain/WorkflowRepositories"
import { WorkflowTemplateListScreenData } from "../domain/WorkflowTemplateListScreenData"
import { WorkflowTest } from "../domain/WorkflowTest"
export class WorkflowTemplateListComponent{
    
    workflow_repo:WorkflowTemplateRepository
    workflow_test_repo:WorkflowTestRepository
    screen_data: WorkflowTemplateListScreenData
    company_id:number
    
    constructor(workflow_repo:WorkflowTemplateRepository,workflow_test_repo:WorkflowTestRepository, screen_data:WorkflowTemplateListScreenData,company_id:number){ 
        this.workflow_repo = workflow_repo
        this.workflow_test_repo = workflow_test_repo
        this.screen_data = screen_data
        this.company_id = company_id
    }


    async refreshList(){
        this.screen_data.loadingItems = true
        let res = await this.workflow_repo.filter_by_company_id(this.company_id, this.screen_data.sort_by, this.screen_data.limit, this.screen_data.offset)
        this.screen_data.setTemplates(res['results'])
        this.screen_data.totalItems = res['count']
        this.screen_data.loadingItems = false
        this.screen_data.selectedItems = []
    }

    async refreshTestsList(){
        this.screen_data.loadingItems = true
        let res = await this.workflow_test_repo.get_workflow_tests(this.screen_data.sort_by, this.screen_data.limit, this.screen_data.offset)
        console.log(res)
        this.screen_data.setTests(res['results'])
        this.screen_data.totalItems = res['count']
        this.screen_data.loadingItems = false
        this.screen_data.selectedItems = []
    }

    async saveSelectedTest(): Promise<{success: boolean, error?: string}> {
        this.screen_data.loading_test = true
        let res = await this.workflow_test_repo.save_workflow_test(this.screen_data.selected_test)
        this.screen_data.loading_test = false
        if (res === 'ok') {
            this.screen_data.detail_test_pop_up = false
            this.screen_data.selected_test = null
            return { success: true }
        } else {
            const errorMsg = res?.error || 'Error saving test'
            console.error("Error saving test:", errorMsg)
            return { success: false, error: errorMsg }
        }
    }

    new_workflow_test() {
        let new_wf_test =  WorkflowTest.createEmpty()
        this.screen_data.selected_test = new_wf_test
        this.screen_data.detail_test_pop_up = true
    }

    async runTest(workflow_test: WorkflowTest) {
        this.screen_data.selected_test = workflow_test
        this.screen_data.selected_test.state = 'running'
        this.screen_data.selected_test.passed = undefined
        this.screen_data.selected_test.errors = []
        await this.workflow_test_repo.run_test(this.screen_data.selected_test)

    }
    
}